import { LOCALE } from '@hhgtech/hhg-components/types'

import { IS_PRODUCTION } from '.'
export const PUBLISHER_ACCOUNT_ID = 158621
export const ADS_COMMON = {
  PUBLISHER_ACCOUNT_ID: 158621,
}

export const CATEGORIES_TO_DISABLE_ADS: { [key in LOCALE]?: string[] } = {
  // [LOCALE.Taiwan]: ['/cancer/'],
  // [LOCALE.Vietnam]: ['/suc-khoe-tinh-duc/', '/the-duc-the-thao/'],
  [LOCALE.Vietnam]: ['/thuoc/', '/duoc-lieu/'],
}

export const CATEGORIES_TO_DISABLE_INITIAL_LOAD_ADS: {
  [key in LOCALE]?: string[]
} = {
  [LOCALE.Taiwan]: ['/health/'],
}

// ALL /health-tools and /bot slug disable ads, except these slugs
export const BOT_SLUGS_STILL_ENABLE_ADS: { [key in LOCALE]?: string[] } = {
  [LOCALE.Thailand]: [
    // '/bot/cervical-cancer/',
    // '/bot/breast-cancer/',
    // '/bot/hpv-tool/',
  ],
}

export const HEALTH_TOOLS_SLUGS_STILL_ENABLE_ADS: {
  [key in LOCALE]?: string[]
} = {
  [LOCALE.Indonesia]: ['/health-tools/kalkulator-masa-subur-2/'],
  [LOCALE.Thailand]: [
    // '/health-tools/เครื่องคำนวณหา-ค่าดัชนี/?result',
  ],
  [LOCALE.Malaysia]: ['/health-tools/graf-tumbesaran-bayi/result/'],
  ...(!IS_PRODUCTION && {
    //for test skinner ads
    [LOCALE.Vietnam]: [
      '/health-tools/tinh-ngay-rung-trung/',
      '/health-tools/cong-cu-tinh-can-nang-khi-mang-thai/',
      '/health-tools/cong-cu-tinh-chi-so-bmi/',
      '/health-tools/tinh-chi-so-bmr/',
      '/health-tools/cong-cu-do-nhip-tim/',
      '/health-tools/bieu-do-tang-truong-cua-tre-em/',
      '/health-tools/lich-tiem-chung/',
      '/health-tools/phan-tre-so-sinh-nhu-the-nao-la-tot/',
    ],
  }),
}

export const CATEGORIES_TO_ENABLE_MOMAGIC_ADS: {
  [key in LOCALE]?: string[]
} = {
  [LOCALE.Taiwan]: [
    //https://hhgdev.atlassian.net/browse/HHD-6373
    // '/stomach/',
    // '/senior-healthcare/',
    // '/drugs-supplement/',
    // '/fitness/',
  ],
}

// https://hhgdev.atlassian.net/browse/HHD-6440
export const MIDBANNER_DISABLE_BY_CAT_PATH: Record<string, string[]> = {
  [LOCALE.Cambodia]: [
    '/ដំណេក/',
    '/%e1%9e%9f%e1%9e%bb%e1%9e%81%e1%9e%97%e1%9e%b6%e1%9e%96%e1%9e%95%e1%9f%92%e1%9e%9b%e1%9e%bc%e1%9e%9c%e1%9e%85%e1%9e%b7%e1%9e%8f%e1%9f%92%e1%9e%8f/',
    '/%e1%9e%87%e1%9f%86%e1%9e%84%e1%9e%ba%e1%9e%86%e1%9f%92%e1%9e%a2%e1%9e%b9%e1%9e%84%e1%9e%93%e1%9e%b7%e1%9e%84%e1%9e%9f%e1%9e%b6%e1%9e%85%e1%9f%8b%e1%9e%8a%e1%9e%bb%e1%9f%86/',
    '/%e1%9e%9f%e1%9e%bb%e1%9e%81%e1%9e%97%e1%9e%b6%e1%9e%96%e1%9e%95%e1%9f%92%e1%9e%9b%e1%9e%bc%e1%9e%9c%e1%9e%8a%e1%9e%84%e1%9f%92%e1%9e%a0%e1%9e%be%e1%9e%98/',
    '/%e1%9e%9f%e1%9e%bb%e1%9e%81%e1%9e%97%e1%9e%b6%e1%9e%96%e1%9e%9f%e1%9f%92%e1%9e%94%e1%9f%82%e1%9e%80/',
  ],
  [LOCALE.India]: [
    '/neurological-bimari/',
    '/sleep/',
    '/oral-swasthya/',
    '/sex-aur-relationship/',
    '/skin-health/',
  ],
  [LOCALE.Indonesia]: [
    '/alergi/',
    '/tht/',
    '/mata/',
    '/muskuloskeletal/',
    '/obat-suplemen/],',
  ],
  [LOCALE.Malaysia]: [
    '/gangguan-darah/',
    '/ubat/',
    '/tidur/',
    '/kesihatan-mental/',
    '/kesihatan-mulut/',
  ],
  [LOCALE.Myanmar]: [
    '/brain-ns/',
    '/healthy-mind/',
    '/respiratory-health/',
    '/sexual-wellness/',
    '/skin-health/',
  ],
  [LOCALE.PhilippinesEnglish]: [
    '/brain-ns/',
    '/healthy-sleep/',
    '/healthy-mind/',
    '/respiratory-health/',
    '/skin-health/',
  ],
  [LOCALE.PhilippinesTagalog]: [],
  [LOCALE.Taiwan]: [
    '/eye-health/',
    '/sleep/',
    '/neurological-problems/',
    '/oral-health/',
    '/senior-healthcare/',
  ],
  [LOCALE.Thailand]: [
    '/%e0%b8%84%e0%b8%a7%e0%b8%b2%e0%b8%a1%e0%b8%9c%e0%b8%b4%e0%b8%94%e0%b8%9b%e0%b8%81%e0%b8%95%e0%b8%b4%e0%b8%82%e0%b8%ad%e0%b8%87%e0%b9%80%e0%b8%a5%e0%b8%b7%e0%b8%ad%e0%b8%94/',
    '/%e0%b8%ab%e0%b8%a5%e0%b8%b1%e0%b8%9a%e0%b8%94%e0%b8%b5-%e0%b8%aa%e0%b8%b8%e0%b8%82%e0%b8%a0%e0%b8%b2%e0%b8%9e%e0%b8%94%e0%b8%b5/',
    '/%e0%b8%ad%e0%b8%ad%e0%b8%a3%e0%b9%8c%e0%b9%82%e0%b8%98%e0%b8%9b%e0%b8%b4%e0%b8%94%e0%b8%b4%e0%b8%81%e0%b8%aa%e0%b9%8c-%e0%b9%82%e0%b8%a3%e0%b8%84%e0%b8%81%e0%b8%a5%e0%b9%89%e0%b8%b2%e0%b8%a1%e0%b9%81%e0%b8%a5%e0%b8%b0%e0%b8%81%e0%b8%a3%e0%b8%b0%e0%b8%94%e0%b8%b9%e0%b8%81/',
    '/%e0%b8%aa%e0%b8%b8%e0%b8%82%e0%b8%a0%e0%b8%b2%e0%b8%9e%e0%b8%8a%e0%b9%88%e0%b8%ad%e0%b8%87%e0%b8%9b%e0%b8%b2%e0%b8%81/',
    '/%e0%b9%82%e0%b8%a3%e0%b8%84%e0%b8%97%e0%b8%b2%e0%b8%87%e0%b9%80%e0%b8%94%e0%b8%b4%e0%b8%99%e0%b8%ab%e0%b8%b2%e0%b8%a2%e0%b9%83%e0%b8%88/',
  ],
  [LOCALE.Vietnam]: [
    '/benh-ve-mau/',
    '/benh-nao-he-than-kinh/',
    '/giac-ngu/',
    '/benh-co-xuong-khop/',
    '/suc-khoe-rang-mieng/',
  ],
}

export const DISABLED_AD_BY_LOCALE: LOCALE[] = []
